import { render, staticRenderFns } from "./ReceiptWarningBanner.vue?vue&type=template&id=97aa2f3c&scoped=true&"
import script from "./ReceiptWarningBanner.vue?vue&type=script&lang=js&"
export * from "./ReceiptWarningBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptWarningBanner.vue?vue&type=style&index=0&id=97aa2f3c&prod&lang=css&"
import style1 from "./ReceiptWarningBanner.vue?vue&type=style&index=1&id=97aa2f3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa2f3c",
  null
  
)

export default component.exports